const sizeStyles = {
    small: { height: 30, padding: '0.25rem 0.313rem' },
    medium: { height: 36, padding: '0.375rem 0.5rem' },
    large: { height: 42, padding: '0.5rem 0.688rem' },
};

const fontStyles = {
    small: { fontSize: '13px', lineHeight: '22px', letterSpacing: '0.46px' },
    medium: { fontSize: '14px', lineHeight: '24px', letterSpacing: '0.4px' },
    large: { fontSize: '15px', lineHeight: '26px', letterSpacing: '0.46px' },
};

export { sizeStyles, fontStyles };
